<template>
    <div>
    <div class="container mt-4 mb-4">
        <boton-atras :nombre_ruta="'estatal'"></boton-atras>
        <div class="row">
            <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                <h6 class="subtitulo mb-2">Acuerdos</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>                
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Acuerdos/acuerdo-UTyCT/UTyCT.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Acuerdo por el que se conforma el Comité de Transparencia de la Secretaría de Finanzas</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Acuerdos/acuerdo-UTyCT/Acreditacion-Virtual.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Acuerdo por el que se aprueba la acreditación de la identidad de la persona titular en la modalidad virtual</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <!--IMPORTANTE!!! CHECAR ESTE ENLACE PORQUE ME MANDA A OTRA PAGINA DE LA PAGINA ORIGINAL DE HACIENDA
                NO ME MANDA A UN ARCHIVO  -->
                <a :href="urlServe+'marco-juridico/Estatal/ACT-2019.asp'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Acuerdos del Comité de Transparencia - 2019 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Enlace <i class='bx bx-link icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/ACT-2016.asp'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Acuerdos del Comité de Transparencia - 2016 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Enlace <i class='bx bx-link icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>


                <!-- CONTENIDO OBTENIDO DIRECTAMENTE DEL SITIO ACTUAL DE HACIENDA (AREA DE COLAPSES) -->
                <!-- <div class="accordion mt-4" id="accordionExample"> -->
                    <div class="card">
                        <div class="card-header" >
                            <h2 class="mb-0">
                                <div class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapse_1" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                                <span><p>Clasificador por Objeto del Gasto del Estado de Chiapas</p></span>
                                <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                </div>
                            </h2>
                        </div>
                        <div  class="" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body">
                                <UL>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Acuerdos/clasificador-OG/COG.pdf'" target="_blank">Descargar</A> </LI>
                                    <LI><p>Catálogo de Bienes Vinculado al Clasificador por Objeto del Gasto y Lista de Cuentas</p></LI>
                                </UL>
                                <ol>
                                    <LI class="ml-4"><A :href="urlServe+'marco-juridico/Estatal/informacion/Acuerdos/clasificador-OG/cat-bienes.pdf'" target="_blank"> Catálogo de Bienes </A> </LI>
                                    <LI class="ml-4"><A :href="urlServe+'marco-juridico/Estatal/informacion/Acuerdos/clasificador-OG/inmuebles.pdf'" target="_blank"> Catálogo de Bienes Inmuebles </A> </LI>
                                    <LI class="ml-4"><A :href="urlServe+'marco-juridico/Estatal/informacion/Acuerdos/clasificador-OG/muebles.pdf'" target="_blank"> Catálogo de Bienes Muebles </A> </LI>
                                </ol>
                                <ul>
                                   <router-link :to="{name: 'estatal-acuerdos-historico'}"><i class="fas fa-plus mr-2 text-vino-strong"></i> Versiones históricas del Clasificador por Objeto del Gasto</router-link>
                                    <!-- <LI> <a href="http://www.haciendachiapas.gob.mx/marco-juridico/Estatal/COG-Hist.asp" target="_blank"> Versiones históricas del Clasificador por Objeto del Gasto</a> </LI> -->
                                </ul>
                            </div>
                        </div>
                    </div>

                <!-- </div> -->
                <!-- TERMINA AREA DE COLAPSES -->
            </div>

            <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                <div class="row margenes">
                    <div class="sec_imagen">
                        <img src="@/assets/imagenes/acuerdo.jpg" alt="">
                    </div>
                </div>
                <!--  -->
                <!--  -->
                <div class="row mt-4 row margenes tab-select">
                    <!-- Componente con el select para seleccionar archivos de ACUERDOS -->
                        <acuerdos-select></acuerdos-select>

                </div>

            </div>
        </div>
    </div>
    <div class="text-aviso my-5">
        <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
    </div>

    </div>
</template>

<script>
import botonAtras from './../../button-atras'
import acuerdosSelect from './acuerdo-select.vue';
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        acuerdosSelect,
        botonAtras,

    }
}
</script>

<style scoped>

.card-header { background-color: #fff; }
.btn-link{ color: #474444; }
.btn:focus { box-shadow: none; }
.btn-link:hover { text-decoration: none; }

li{
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }


/*  */
    .title_document {
        padding: .8rem 1rem;
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    }

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    /*
    lo cambie a estilos.css
    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    } */
    /*

    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    } */
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        /* line-height: 20px; */
    }

    .sec_imagen{
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }

    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>
